import React, {useContext} from 'react';
import IconButton from '@common/IconButton';
import {MenuIcon} from '@common/icons';
import SwitchLeftRoundedIcon from '@mui/icons-material/SwitchLeftRounded';
import SwitchRightRoundedIcon from '@mui/icons-material/SwitchRightRounded';
import {UserContext} from "@context/UserContext";

const Header = props => {
    const {navRightCompressed, toggleNav, toggleRightNavCompressed} = props;
    const {user} = useContext(UserContext);

    return (
        <div className={'ch-header'}>
            <IconButton
                className={'ch-icon-btn-on-global'}
                onClick={() => {toggleNav()}}
                size="large">
                <MenuIcon />
            </IconButton>
            <div className="ch-header-title">{user.syllabusName}</div>
            <IconButton
                className={'ch-icon-btn-on-global'}
                onClick={() => {toggleRightNavCompressed()}}
                size="large">
                {navRightCompressed &&
                    <SwitchRightRoundedIcon fontSize="large" sx={{color: 'var(--on-global-menu-colour)'}}/>
                }
                {!navRightCompressed &&
                    <SwitchLeftRoundedIcon fontSize="large" sx={{color: 'var(--on-global-menu-colour)'}}/>
                }
            </IconButton>
        </div>
    );
}

export default Header;